import { Component, OnInit } from '@angular/core';
import { LlmProviderService } from '../../../../Services/llmProvider.service';
import { LLMUsageSummary } from '../../../../Model/AI/LLMProvider';

@Component({
    selector: 'llm-usage',
    templateUrl: 'llmUsage.component.html',
    styleUrls: ['llmUsage.component.css'],
    standalone: false
})
export class LlmUsageComponent implements OnInit {
  public usage: LLMUsageSummary = null;
  public selectedRange = 30;

  public ranges = [
    { days: 7, name: 'Letzte 7 Tage' },
    { days: 30, name: 'Letzte 30 Tage' },
    { days: 90, name: 'Letzte 90 Tage' }
  ];

  constructor(private llmProviderService: LlmProviderService) {
  }

  ngOnInit(): void {
    this.load();
  }

  public onRangeChanged(event: any): void {
    this.selectedRange = event.value;
    this.load();
  }

  private load(): void {
    this.llmProviderService.getUsage(this.selectedRange)
      .subscribe(usage => this.usage = usage);
  }
}
